import MainLayout from '@/components/layouts/main-layout';
import socialMediaLinks from '@/data/social-media-links';
import SocialMediaLink from '@/components/common/social-media-link';
import {FormattedMessage} from 'react-intl';
import type {FC} from 'react';

const AboutPage: FC = (): JSX.Element => (
  <MainLayout metadata={{title: 'About - Soubul'}}>
    <div className="flex flex-1 container mx-auto">
      <div className="w-full bg-white border rounded-lg shadow my-12 p-12">
        <h1 className="text-5xl font-bold mb-4">
          <FormattedMessage id="words.soubul" />
        </h1>
        <p className="font-light text-2xl opacity-80 mb-12">
          <FormattedMessage id="words.create_your_future" />
        </p>
        <p className="mb-12 opacity-90">
          <FormattedMessage id="content.about" />
        </p>
        <p className="font-light text-2xl opacity-80 mb-6"><FormattedMessage id="words.contact_us"/></p>
        <section className="flex flex-1 items-center">
          {socialMediaLinks.map(({key, ...rest}) => (
            <div key={key} className="mx-2">
              <SocialMediaLink {...rest} />
            </div>
          ))}
        </section>
      </div>
    </div>
  </MainLayout>
);

export default AboutPage;
